
/*


 -- This is just the info that goes at the top of the BMP Selection tab --


*/

export default function BMPSelectionInfo () {
    return (
        <>
        <h2 className="text-lg font-semibold mb-4">BMP Selection</h2>
          <p className="text-sm text-gray-700 mb-4">
            Configure your BMP analysis parameters. These selections will be used across all analysis tabs.
          </p>
          <div className="mb-6">
            <div className="mb-2">
              <div className="text-sm">
                This web app visualizes data submitted to the <a 
                    href="https://smc-bmp-sccwrp.hub.arcgis.com/" 
                    target="_blank"
                    className="text-blue-700 underline"
                >
                    SMC BMP Regional Monitoring Network
                </a>. You may choose the “individual BMPs” or “BMP type”. As of Nov. 2025, the only BMP type available is bioretention. 
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-6 text-sm">
              <div className="flex-1">
                
                <div>Analysis types include:</div>
                <ul className="list-disc ml-6">
                  <li>BMP Types (i.e. Bioretention cells, Grass Strips, etc.)</li>
                  <li>
                    Individual BMPs
                    <ul className="list-disc ml-6">
                      <li>
                        <p>User must know the name of the BMP of interest.</p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              
            </div>
          </div>
        </>
    )
}